module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-image-editor"
  }, [_c('div', {
    staticClass: "padding-bottom"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor(_vm.data)
      }
    }
  }, [_vm._v("\n\t\t\tBild aus MAM laden\n\t\t")]), _vm._v(" "), (_vm.imageData.value) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.prepareImageDeletion
    }
  }, [_vm._v("\n\t\t\tBild löschen\n\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('erco-image-editor', {
    ref: "image-editor",
    attrs: {
      "data": _vm.imageData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ceb2b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/ImageEditor.vue
// module id = 602
// module chunks = 0